import React from "react";
import { useTranslation } from "react-i18next";
import { useLegalDocument } from "../../hooks/useLegalDocument";
import LegalDocumentBody from "./LegalDocumentBody";

const StudentTermsPage: React.FC = () => {
  const { t } = useTranslation();
  const { doc: studentDoc } = useLegalDocument("student_terms");

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">{t("Student Terms & Conditions")}</h1>
      <p className="text-sm text-gray-500 mb-6">
        {t("Last Updated")}: {studentDoc?.effective_at ? new Date(studentDoc.effective_at).toLocaleDateString() : "2026-10-13"}
      </p>
      <LegalDocumentBody doc={studentDoc} fallback={null} />
    </div>
  );
};

export default StudentTermsPage;
